
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-help',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './help.component.html',
    styleUrl: './help.component.scss',
})
export class HelpComponent {
    isTp: boolean = false;

    constructor(
        private router: Router,
        private storageService: StorageService
    ) {}

    ngOnInit() {
        this.isTp = this.router.url.includes('helptp');
    }

    openLink(str: string) {
        if (this.storageService.getMobile()) {
            confirm(str);
        } else {
            window.open(str, '_blank');
        }
    }
}
